import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { STORAGE_KEYS, sessionStorageService } from "service/storage";

/**
 * Custom hook to handle post-authentication navigation
 * Navigates to the stored state after successful authentication
 * @param state - The navigation state from authentication
 */
export const usePostAuthNavigation = (state: string | null | undefined) => {
  const [hasNavigated, setHasNavigated] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    // CX-3744: a deferred CTA deep link (usePostLoginRedirect) takes precedence
    // over the generic previous-page restore — don't clobber it here.
    if (sessionStorageService.getItem(STORAGE_KEYS.POST_LOGIN_REDIRECT)) return;
    if (state && !hasNavigated) {
      navigate(state, { replace: true });
      setHasNavigated(true);
    }
  }, [state, hasNavigated, navigate]);

  return hasNavigated;
};
